import type {
  AppEvent,
  ConversationUpdatedEvent,
} from '../../interfaces/websocket-events.interface'
import { logger } from '../../utils/logger.util'
import { agentsApiSlice } from '../agents-api.store'
import type { WebSocketStoreApi } from './websocket-store.helper'

const handleConversationUpdated = (
  store: WebSocketStoreApi,
  event: ConversationUpdatedEvent
): void => {
  const { conversation_id: conversationId, conversation_name: conversationName } = event
  if (!conversationId || !conversationName) return

  store.dispatch(
    agentsApiSlice.util.invalidateTags([
      { type: 'Conversation', id: conversationId },
      'Conversations',
    ])
  )
}

const handlers: Record<string, (store: WebSocketStoreApi, event: AppEvent) => void> = {
  conversation_updated: (store, event) =>
    handleConversationUpdated(store, event as ConversationUpdatedEvent),
}

export const isAppEvent = (data: unknown): data is AppEvent =>
  typeof data === 'object' &&
  data !== null &&
  'type' in data &&
  typeof (data as { type: unknown }).type === 'string' &&
  (data as { type: string }).type in handlers

export const handleAppEvent = (store: WebSocketStoreApi, event: AppEvent): boolean => {
  const handler = handlers[event.type]
  if (!handler) {
    logger.warn('Unhandled app event type', { type: event.type })
    return false
  }
  handler(store, event)
  return true
}
